import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MerchantUserRegistrationComponent } from './merchant-user-registration/merchant-user-registration.component';

const routes: Routes = [
  { path: '', component: MerchantUserRegistrationComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MerchantUserRegistrationRoutingModule {}
